var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcCheck = function SvgIcCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.09.744a.833.833 0 0 1 0 1.179L5.756 9.256a.833.833 0 0 1-1.178 0L.91 5.589a.833.833 0 0 1 1.178-1.178l3.079 3.077L11.91.744a.833.833 0 0 1 1.178 0",
    clipRule: "evenodd"
  })));
};
export default SvgIcCheck;